"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _lodash2 = _interopRequireDefault(require("lodash.clonedeep"));

var _common = require("../../../common");

var _BrandValueSection = _interopRequireDefault(require("../BrandValueSection"));

require("./styles/_our-brand.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NEW_BRAND_VALUE = function NEW_BRAND_VALUE() {
  return {
    key: Date.now(),
    value: '',
    description: ''
  };
};

var OurBrand = /*#__PURE__*/function (_Component) {
  _inherits(OurBrand, _Component);

  var _super = _createSuper(OurBrand);

  function OurBrand(props) {
    var _this;

    _classCallCheck(this, OurBrand);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateInputField", (0, _lodash.default)(function (fieldName) {
      return function (result) {
        _this.setState(_defineProperty({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "updateBrandValueInputField", (0, _memoizeOne.default)(function (index, fieldName) {
      return function (result) {
        _this.setState(function (_ref) {
          var prevBrandValues = _ref.brandValues;
          var brandValues = (0, _lodash2.default)(prevBrandValues);
          var brandValue = brandValues[index];
          brandValue[fieldName] = (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result);
          return {
            brandValues: brandValues
          };
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "removeBrandValue", (0, _lodash.default)(function (index) {
      return function () {
        _this.setState(function (_ref2) {
          var prevBrandValues = _ref2.brandValues;

          var brandValues = _toConsumableArray(prevBrandValues);

          brandValues.splice(index, 1);
          return {
            brandValues: brandValues
          };
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "addBrandValue", function () {
      _this.setState(function (_ref3) {
        var prevBrandValues = _ref3.brandValues;
        return {
          brandValues: [].concat(_toConsumableArray(prevBrandValues), [NEW_BRAND_VALUE()])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaveAndContinue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, goToNextWizardStage, updateSubBrand, _this$state, name, vision, overview, mission, brandValues;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, goToNextWizardStage = _this$props.goToNextWizardStage, updateSubBrand = _this$props.updateSubBrand;
              _this$state = _this.state, name = _this$state.name, vision = _this$state.vision, overview = _this$state.overview, mission = _this$state.mission, brandValues = _this$state.brandValues;

              _this.setState({
                saving: true
              });

              updateSubBrand({
                name: name,
                vision: vision,
                mission: mission,
                overview: overview,
                brandValues: brandValues
              });
              return _context.abrupt("return", void goToNextWizardStage());

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    var _props$subBrand = props.subBrand;
    _props$subBrand = _props$subBrand === void 0 ? {} : _props$subBrand;
    var _name = _props$subBrand.name,
        _overview = _props$subBrand.overview,
        _vision = _props$subBrand.vision,
        _mission = _props$subBrand.mission,
        _brandValues = _props$subBrand.brandValues;
    _this.state = {
      name: _name,
      overview: _overview,
      vision: _vision,
      mission: _mission,
      saving: false,
      brandValues: _brandValues || [NEW_BRAND_VALUE()]
    };
    return _this;
  }

  _createClass(OurBrand, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          saving = _this$state2.saving,
          brandValues = _this$state2.brandValues,
          vision = _this$state2.vision,
          mission = _this$state2.mission,
          name = _this$state2.name,
          overview = _this$state2.overview;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "our-brands__container"
      }, /*#__PURE__*/_react.default.createElement(_common.PageTitle, {
        title: "Our Brand"
      }), /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        className: "brand-name",
        placeholder: "Enter Brand Name",
        defaultValue: name,
        onChange: this.updateInputField('name'),
        label: "Brand Name",
        labelProps: {
          required: true
        }
      })), /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_common.OverviewSummary, {
        iconLabel: "Overview",
        textLabel: "Summary",
        placeholder: "Enter Summary",
        defaultValue: overview,
        handleChange: this.updateInputField('overview')
      })), /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_common.LabelWithIcon, {
        label: "Mission Statement"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "our-brands__container__input"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        className: "brand-vision",
        multiline: true,
        label: "Vision",
        placeholder: "Enter Vision",
        defaultValue: vision || '',
        onChange: this.updateInputField('vision'),
        rows: 2
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "our-brands__container__input"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        className: "brand-mission",
        multiline: true,
        label: "Mission",
        placeholder: "Enter Mission",
        defaultValue: mission || '',
        onChange: this.updateInputField('mission'),
        rows: 2
      }))), /*#__PURE__*/_react.default.createElement(_BrandValueSection.default, {
        addBrandValue: this.addBrandValue,
        values: brandValues,
        removeBrandValue: this.removeBrandValue,
        updateBrandValueInputField: this.updateBrandValueInputField
      }), /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        className: "our-brands__container__save-continue save-button",
        onClick: this.handleSaveAndContinue,
        busy: saving,
        disabled: !name
      }, "Save & Continue")));
    }
  }]);

  return OurBrand;
}(_react.Component);

var _default = OurBrand;
exports.default = _default;